<template>
	<div>
		<NavBar />

		<div style="min-height: 80vh">
			<slot />
		</div>

	</div>
</template>

<script>
	import NavBar from "./components/navbar.vue";

	export default {
		name: "DefaultLayout",

		data() {
			return {};
		},

		components: {
			NavBar
		},
	};
</script>
